import { render, staticRenderFns } from "./VesselRegister.vue?vue&type=template&id=571b6930"
import script from "./VesselRegister.vue?vue&type=script&lang=js"
export * from "./VesselRegister.vue?vue&type=script&lang=js"
import style0 from "./VesselRegister.vue?vue&type=style&index=0&id=571b6930&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports